import { createContext } from "react";

export const TableContext = createContext<{ editable: boolean; compact: boolean } | null>(null);
